
export class CronWrapper {
bu: string;
code: string;
domain: string;
job: any;
jobs: any[];
visionCode: string;
}

